import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";


const Table8 = ({ koosheshEhsasiScore, SetKoosheshEhsasiScore, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)

  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.koosheshEhsasi;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 8, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 16, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 24, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 32, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 40, isSelected: masouliat.value == 4 },

      ]

      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      SetKoosheshEhsasiScore(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "koosheshEhsasi": selectedItem }))
    }
  }, [reload])



  return (
    <div>
      <Row type={1}>

        <Column >سطح یک</Column>
        <Column >سطح دو</Column>
        <Column >سطح سه</Column>
        <Column >سطح چهار</Column>
        <Column >سطح پنج</Column>

      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          خواندن احساسات
        </Column>
        <Column paddingY={30}>
          شدت ابراز احساسات
        </Column>
        <Column paddingY={30}>
          فراوانی ابراز
          احساسات
        </Column>
        <Column paddingY={30}>
          مدیریت احساسات
          خود
        </Column>
        <Column paddingY={30}>
          مدیریت احساسات طرف
          مقابل
        </Column>
      </Row>
      {/* <Row type={3}>
        <Column>زیاد</Column>
        <Column>متوسط</Column>
        <Column>متوسط</Column>
        <Column>زیاد</Column>
        <Column>زیاد</Column>
      </Row> */}
      <Row>
        <Column isActive={koosheshEhsasiScore == 8}> 8</Column>
        <Column isActive={koosheshEhsasiScore == 16}>16 </Column>
        <Column isActive={koosheshEhsasiScore == 24}>24 </Column>
        <Column isActive={koosheshEhsasiScore == 32}> 32</Column>
        <Column isActive={koosheshEhsasiScore == 40}> 40</Column>
      </Row>
    </div>
  );
};

export default Table8;
